import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Card, Modal, ModalCloseButton, Section } from '..';
import * as Styled from './styled';
import type { ApplicationSuggestionModalProps } from './types';

export * from './types';

export const ApplicationsSuggestionModal: FC<ApplicationSuggestionModalProps> = (props) => {
  const { modal, children } = props;
  const { translate } = useTranslation();

  return (
    <Modal {...modal}>
      <Card size="large" isModal>
        <ModalCloseButton modal={modal} />
        <Section centerChildren>
          <Styled.ModalSectionTitle>
            {translate('common.modals.suggestedBreeders.title')}
          </Styled.ModalSectionTitle>

          <Section>
            {/* <InfoBox>
              We will resend your recent application. You can check your last answers here
            </InfoBox> */}

            {children}
          </Section>
        </Section>
      </Card>
    </Modal>
  );
};
